export enum FaqCategory {
  IMAX_STRATEGY = "imax",
  PLANS = "plans",
  OFFLINE = "offline",
}
